import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=4a8953f0&scoped=true&"
import script from "./pure.vue?vue&type=script&lang=js&"
export * from "./pure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8953f0",
  null
  
)

export default component.exports